import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { adfModelTypeMap, fileTypeLinkedServiceTypes } from '../consts/adf-model-type-map-const';

import {
    jsonCompressionTypeOptions,
    xmlEncodingNameOptions
} from '../consts/v2Dataset-const';
import { compressionCodecType } from 'shell-models-lib';
import { ISelectOption } from 'app/interfaces/ISelectOption';
import { preserveCompressionFileAsFolderMetadata, preserveZipFileAsFolderMetadata } from '../consts/metadata-consts';

export const xmlValidationModeOptions: Array<ISelectOption<string>> = [
    {
        label: stringResources.None,
        value: 'none'
    },
    {
        label: 'xsd',
        value: 'xsd'
    },
    {
        label: 'dtd',
        value: 'dtd'
    }
];

export const xmlMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.xml.datasetType,
    displayName: stringResources.ModelName_XmlDataset,
    supportLinkedServiceTypes: __IS_FABRIC_DPE__ ? fileTypeLinkedServiceTypes : fileTypeLinkedServiceTypes.filter((type) => type !== adfModelTypeMap.lakehouse.linkedServiceType),
    isSource: true,
    isSink: false,
    datasetKind: 'hierarchical',
    notSupportTypeConversion: true,
    icon: {
        className: 'svg-i-20x20-Xml'
    },
    isFirstClass: true,
    category: ['File'],
    isV2FormatDataset: true,
    supportDataFlowSource: true,
    notSupportPhysicalType: true,
    supportGetMetadataActivity: true,
    supportDeleteActivity: true,
    compressionOptions: jsonCompressionTypeOptions,
    encodingOptions: xmlEncodingNameOptions,
    fileExtensions: ['*.xml', '*'],
    formatReadSettingControls: [
        {
            type: 'parameterizable',
            child: {
                type: 'select',
                bind: 'validationMode',
                label: stringResources.DataFlowSourceSettingsValidationMode,
                description: stringResources.DataFlowSourceSettingsValidationModeDescription,
                options: xmlValidationModeOptions,
                defaultValue: 'none',
                hasFilter: false
            },
            dynamicContentTextClass: 'input-spaced'
        },
        {
            type: 'xml-namespace-prefix',
            bind: {
                namespaces: 'namespaces',
                namespacePrefixes: 'namespacePrefixes'
            },
            parameterizable: true,
            noNameSpaceCheckbox: false
        },
        {
            type: 'parameterizable',
            child: {
                type: 'checkbox',
                bind: 'detectDataType',
                label: stringResources.DataFlow_DetectDataType,
                defaultValue: true
            },
            dynamicContentTextClass: 'input-spaced'
        }
    ],
    compressionReadSettingControls: {
        [compressionCodecType.ZipDeflate]: [preserveZipFileAsFolderMetadata],
        [compressionCodecType.TarGZip]: [preserveCompressionFileAsFolderMetadata],
        [compressionCodecType.tar]: [preserveCompressionFileAsFolderMetadata]
    }
};
